'use client';
import React, { memo } from 'react';
import useApplyLogging from '../../hooks/useApplyLogging.mjs';

function IcClose(customProps) {
  const {
    fill,
    ...props
  } = customProps;
  useApplyLogging('ICON_IcClose');
  return /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.36375 3.3637C3.01228 3.71517 3.01228 4.28502 3.36375 4.63649L19.3638 20.6365C19.7152 20.988 20.2851 20.988 20.6365 20.6365C20.988 20.285 20.988 19.7152 20.6365 19.3637L4.63654 3.3637C4.28507 3.01223 3.71522 3.01223 3.36375 3.3637Z",
    fill: fill || '#1E1E23'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6365 3.3637C20.988 3.71517 20.988 4.28502 20.6365 4.63649L4.63649 20.6365C4.28502 20.988 3.71517 20.988 3.3637 20.6365C3.01223 20.285 3.01223 19.7152 3.3637 19.3637L19.3637 3.3637C19.7152 3.01223 20.285 3.01223 20.6365 3.3637Z",
    fill: fill || '#1E1E23'
  }));
}
var IcClose$1 = /*#__PURE__*/memo(IcClose);

export { IcClose$1 as default };
